import { render } from "./LeftMenu.vue?vue&type=template&id=48aeb6fe&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=js"
export * from "./LeftMenu.vue?vue&type=script&lang=js"

import "./LeftMenu.vue?vue&type=style&index=0&id=48aeb6fe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-48aeb6fe"

export default script